export class BackupZeroEtlIcebergPartitionTransform {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columnName",
            "baseName": "columnName",
            "type": "string",
            "format": ""
        },
        {
            "name": "transformType",
            "baseName": "transformType",
            "type": "BackupZeroEtlIcebergTransformType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlIcebergPartitionTransform.attributeTypeMap;
    }
    constructor() {
    }
}
